/** @format */
import { smallButtonSizeStyles } from '@mpb-com/feather/components/atoms/button/button.styles';
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
const baseStyles = css`
    position: relative;
    cursor: grab;
    touch-action: none;

    ::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    & .article-tile {
        pointer-events: none;
        margin-right: 0;
        filter: blur(20px) brightness(1.5);
    }

    .see-all {
        position: absolute;
        top: 50%;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    ${smallTablet(css`
        ${smallButtonSizeStyles}
    `)};
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

export const styles = () => css`
    ${baseStyles}
`;
